import React from 'react';
import {BaseMixin, ElementaryMixin, NestingLevelMixin} from '../common/common.js';

import './glyphicon.less';

export const Glyphicon = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Glyphicon',
    nestingLevel: 'inline',
    classNames: {
      main: 'uu5-bricks-glyphicon glyphicon'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    glyphicon: React.PropTypes.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      glyphicon: 'uu-glyphicon-ok'
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    var mainProps = this.buildMainAttrs();
    mainProps.className += ' ' + this.props.glyphicon;

    return (
      this.getNestingLevel()
        ? (
          <span {...mainProps}>
            {this.props.children && React.Children.toArray(this.props.children)}
            {this.getDisabledCover()}
          </span>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Glyphicon;



// WEBPACK FOOTER //
// ./bricks/glyphicon.js